import React, { useState, useEffect } from "react";
import {
  useGetBuyerCartDataQuery,
  usePostPurchaseOrderMutation,
  useGetDeliveryAllDocumentsQuery,
  useNegotiationTimelineMutation,
  usePostCheckAvailabilityMutation,
} from "./ProcurementApiSlice";
import { Modal, Spinner } from "react-bootstrap";
import SellerNegotiationModal from "./SellerNegotiationModal";
import DeliveryDocs from "./DeliveryDocs";
import PaymentDocs from "./PaymentDocs";
import QualityParamsModal from "./QualityParamsModal";
import CancelIcon from "@mui/icons-material/Cancel";

import { toast } from "react-toastify";
import {
  Popover,
  IconButton,
  Tooltip,
  Typography,
  MenuItem,
  Button,
  Select,
  Card,
  CardContent,
  Grid,
  Box,
  useMediaQuery,
  useTheme,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SkeletonLoader from "./SkeletonLoader";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NoData from "features/MobileProcurement/NoData";
import NegotiateWithSeller from "./NegotiateWithSellerModal";
import { DetailDescriptionSeller } from "./DetailDescriptionSeller";
import CreateBuy from "./CreateBuy";
import BuyerLeadList from "./BuyerLeadList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import GetBuyersTradingList from "./GetBuyersTradingList";

const BuyerCart = ({ user_id, activeCard, UserData }) => {
  let initial = "";
  const {
    data: getStockWiseCommodity,
    isLoading,isFetching,
    refetch,
  } = useGetBuyerCartDataQuery(
    { user_id: user_id, initial: initial },
    { refetchOnReconnect: true }
  );
  const [ProcCode, setProcCode] = useState("");

  const {
    data: AddResponse,
    refetch: refetchAddResponse,
  } = useGetDeliveryAllDocumentsQuery(ProcCode, { skip: !ProcCode });
  const [checkAvailability] = usePostCheckAvailabilityMutation();

  const [CommodityData, setCommodityData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, per_page: 10 });
  const [negotiationModal, setNegotiationModal] = useState(false);
  const [negotiationItem, setNegotiationItem] = useState("");
  const [BuyersActiveList, setBuyersActiveList] = useState("");
  const [FullList, setFullList] = useState([]);
  const [show, setShow] = useState(false);
  const [InitiateTradeShow, setInitiateTradeShow] = useState(false);
  const [statusRecords, setStatusRecords] = useState("");
  const [negotiatioanValues, setNegotiationValue] = useState({});
  const [postPurchase] = usePostPurchaseOrderMutation();
  const [triggerTab2Api, setTriggerTab2Api] = useState(false);
  const [negotiationView, setNegotiationView] = useState(null);
  const [timelineloader, settimelineloader] = useState(false);
  const [increaseTimeline] = useNegotiationTimelineMutation();
  const [anchorTimeline, setAnchorTimeline] = useState(null);
  const [selectedDay, setSelectedDay] = useState("");
  // const [showFields, setShowFields] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [availableStock, setAvailableStock] = useState("");
  const handleClose = () => {
    setShow(false);
    // refetch()
  };
  const [showPayment, setShowPayment] = useState(false);
  const handleClosePayment = () => setShowPayment(false);
  // console.log("getStockWiseCommodity",getStockWiseCommodity)
  useEffect(() => {
    if (getStockWiseCommodity) {
      setCommodityData(getStockWiseCommodity?.data?.results);
    }
    if (AddResponse !== undefined) {
      setStatusRecords(AddResponse?.data);
    }
  }, [getStockWiseCommodity, activeCard, AddResponse]);
  const handleNegotiation = (item) => {
    if (item.is_initial_relationship) {
      let formData = {
        crop_id: item.crop_code,
        user_id: item.created_for_id,
        quantity: item.final_quantity?item.final_quantity:item.quantity,
        use_quantity: true

      };
      checkAvailability(formData)
        .unwrap()
        .then((data) => {
          setAvailableStock(data?.data?.available_stock);
        })
        .catch((data) => {
          setAvailableStock(data?.data?.available_stock);
        });
    }

    setNegotiationModal(true);
    setNegotiationItem(item);
    setBuyersActiveList(item);
    // setShowFields(false)
  };

  const [qualityParams, setQualityParams] = useState("");
  const [anchorEl, setAnchorEl] = useState(false);
  const [value, setValue] = useState("ongoing");

  const handleChangeTabs = (newValue) => {
    setValue(newValue);
    setInitiateTradeShow(false);
  };
  const handleDeliveryModal = (list) => {
    setShow(true);
    setFullList(list);
    setProcCode(list.ProcCode);
    setAnchorElPayment(null);
  };
  const handlePaymentModal = (list) => {
    setShowPayment(true);
    setFullList(list);
    setAnchorElPayment(null);
  };
  const handlePopoverClose = () => {
    setAnchorEl(false);
  };

  const [anchorElPayment, setAnchorElPayment] = useState(null);
  const handlePopoverClosePayment = () => {
    setAnchorElPayment(null);
  };
  const handlePopoverOpenPayment = (event, list) => {
    setAnchorElPayment(event.currentTarget);
    setFullList(list);
    setProcCode(list.ProcCode);
  };

  const handleDownload = (list) => {
    const filteredList = list.find((item) => item.pattern === "Purchase Order");
    if (filteredList) {
      const fileUrl = filteredList.file;
      window.open(fileUrl, "_blank");
    } else {
      console.error("Purchase Order file not found in the list");
    }
  };
  const [anchorElDo, setAnchorElDo] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const handleUploadIconClick = (event, list) => {
    setAnchorElDo(event.currentTarget); // Set the anchor element to the icon clicked
    setFullList(list);
    setAnchorElPayment(null);
  };

  const handleCloseDo = () => {
    setAnchorElDo(null); // Close the popover
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("entity_type", "Buyer");
    formData.append("category", "Procurement");
    formData.append("pattern", "15");
    formData.append("ProcCode", FullList?.ProcCode);
    formData.append("user_id", user_id);
    postPurchase(formData)
      .unwrap()
      .then(async (data) => {
        toast.success("Purchase Order Updated !!");
        setSelectedFile("");
        setFullList("");
        setAnchorElDo(null);
        await refetch();
      })
      .catch((error) => {
        toast.error("Something went wrong !!");
        return;
      });
  };

  const [anchorElInvoice, setAnchorElInvoice] = useState(null);
  const handleGenerateInvoice = (event, list) => {
    setAnchorElInvoice(event.currentTarget); // Set the anchor element to the icon clicked
    setFullList(list);
  };

  const handleCloseInvoice = () => {
    setAnchorElInvoice(null); // Close the popover
  };

  const handleStatus = (row) => {
    const {
      status,
      dispatch_status,
      delivery_status,
      document_status,
      payments,
    } = row || {};
    let displayStatus = status;
    if(status==="Closed"){
      return displayStatus
  }
    if (dispatch_status !== "Pending" && delivery_status === "Pending") {
      displayStatus = dispatch_status;
    } else if (delivery_status !== "Pending" && dispatch_status !== "Pending") {
      displayStatus = delivery_status;
    }
    if (document_status.payment_sheet_buyer && status !== "Completed") {
      displayStatus = payments.buyer_status;
    }
    if (document_status.payment_sheet_partner && status === "Completed") {
      displayStatus = status;
    }
    return displayStatus;
  };

  // const handleRefreshButton = () => {
  //   if (value === "selfInitiated") {
  //     setTriggerTab2Api(true);
  //   } else if (value === "ongoing") setTriggerTab2Api(false);
  //   refetch();
  // };
  const handleRefreshButton = async () => {
    if (value === "selfInitiated") {
      setTriggerTab2Api(true);
    } else if (value === "ongoing") setTriggerTab2Api(false);
    setIsRefetching(true); // Set loading to true before refetching
    await refetch(); // Wait for API response
    setIsRefetching(false); // Turn off loading after refetch
  };
  const handlePopoverOpenTimeline = (event, item) => {
    setAnchorTimeline(event.currentTarget);
    setFullList(item);
  };

  const handleIncreaseTimeline = () => {
    const id = FullList?.ProcCode;
    let payload;
    payload = {
      valid_until: selectedDay === 1 ? "24" : selectedDay === 2 ? "48" : "72",
      trade_initiated: "Buyer",
    };
    settimelineloader(true);
    increaseTimeline({ id: id, payload: payload })
      .unwrap()
      .then(async (data) => {
        toast.success("Timeline Updated!");
        setAnchorTimeline(null);
        setSelectedDay("");
        settimelineloader(false);
        await refetch();
      })
      .catch(() => {
        toast.error("Something went wrong! We will get back Soon!!");
        settimelineloader(false);
      });
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack vertically on small devices
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          padding: { xs: "8px", sm: "16px" },
          // backgroundColor: "#F5F5F5",
          borderRadius: "8px",
          // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <RadioGroup
          row
          value={value}
          onChange={(e) => handleChangeTabs(e.target.value)}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            alignItems: "center",
            marginBottom: "0px",
          }}
        >
          <FormControlLabel
            value="ongoing"
            control={<Radio color="warning" />}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/512/12925/12925052.png"
                  alt="Self Initiated"
                  style={{ width: 20, height: 20 }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: value === "ongoing" ? "orange" : "black",
                    fontWeight: value === "ongoing" ? "bold" : "normal",
                  }}
                >
                  Ongoing Trades
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="selfInitiated"
            control={<Radio color="warning" />}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/256/8712/8712832.png"
                  alt="selfInitiated Initiated"
                  style={{ width: 20, height: 20 }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: value === "selfInitiated" ? "orange" : "black",
                    fontWeight: value === "selfInitiated" ? "bold" : "normal",
                  }}
                >
                  Self Initiated Trades
                </Typography>
              </Box>
            }
          />
        </RadioGroup>
        {!InitiateTradeShow ? (
          <div>
            <Tooltip title="Initiate Trade" arrow>
              <Button
                variant="contained"
                className="buttonOrangeDefaultColor mt-2 mx-2 "
                onClick={() => {
                  setInitiateTradeShow(true);
                }}
              >
                <AddIcon />
                &nbsp;&nbsp;Initiate Trade
              </Button>
            </Tooltip>
            <Button
              variant="contained"
              onClick={() => handleRefreshButton()}
              className="bg-transparent text-black mx-2 p-2"
              style={{
                border: "1px solid #829999",
                color: "#343737",
              }}
            >
              <FontAwesomeIcon icon={faRotateLeft} />
            </Button>
          </div>
        ) : (
          <Button
            className="float-end p-2"
            variant="outlined"
            color="error"
            size="sm"
            onClick={() => setInitiateTradeShow(false)}
          >
            Cancel <FontAwesomeIcon icon={faRotateLeft} />
          </Button>
        )}
      </Box>
      {value === "ongoing" && !InitiateTradeShow ? (
        <>
          {isLoading || isRefetching || isFetching ? (
            <SkeletonLoader />
          ) : CommodityData?.length > 0 ? (
            <Grid container spacing={2} className="">
              {CommodityData?.map((row, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    variant="outlined"
                    sx={{
                      padding: 2,
                      borderRadius: "12px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      transition: "transform 0.3s",
                      "&:hover": { transform: "scale(1.02)" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: {  sm: "row" },
                        alignItems: { xs: "center", sm: "flex-start" },
                        marginBottom: 1.5,
                      }}
                    >
                      {row.image_url && (
                        <Box
                          component="img"
                          src={row.image_url}
                          alt={row.crop_name}
                          sx={{
                            width: "70px",
                            height: "70px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            marginBottom: { xs: 1, sm: 0 },
                            marginRight: { sm: 2 },
                          }}
                        />
                      )}

                      <Box
                        sx={{
                          flex: 1,
                          textAlign: { xs: "center", sm: "left" },
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 600 }}
                        >
                          {row.crop_name.replace(/_/g, " ")}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "text.secondary" }}
                        >
                          Created: {row.created_at.slice(0, 10)}
                        </Typography>
                      </Box>
                      {row?.negotiation_detail?.is_expired &&
                        row?.status === "Negotiation In progress"?
                          <Tooltip title="Increase Timeline">
                            <span
                              className="contract_note cursor-pointer mx-2"
                              onClick={(event) =>
                                handlePopoverOpenTimeline(event, row)
                              }
                            >
                              Increase Timeline &nbsp;
                              <AccessTimeIcon
                                size="small"
                                className="badge-icon"
                              />
                            </span>
                          </Tooltip>
                        :""}

                      {(row.status === "Purchase Order Generated" ||
                        row.status === "Purchase Order Uploaded" ||
                        row?.document_status?.b2s_invoice ||
                        row.status === "Invoice In Progress") && (
                        <IconButton
                          size="small"
                          onClick={(e) => handlePopoverOpenPayment(e, row)}
                          sx={{ alignSelf: "flex-start", marginLeft: "auto" }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      )}
                    </Box>

                    <CardContent sx={{ paddingTop: 0 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: {  sm: "row" },
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          Quantity:{" "}
                          <strong>
                            {row.final_quantity || row.quantity}{" "}
                            {row.unit_of_measure}
                          </strong>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          Price/Unit:{" "}
                          <strong> ₹ {row.final_price || row.price}</strong>
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexWrap: { xs: "wrap", sm: "nowrap" },
                          marginBottom: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <AccessTimeIcon
                            fontSize="small"
                            sx={{ marginRight: 0.5 }}
                          />
                          Payment : {" "}
                          {row?.delivery_and_payment_detail?.payment_type ||
                            "-"}{" "}
                          {row?.delivery_and_payment_detail?.payment_type ===
                            "D+" &&
                          row?.delivery_and_payment_detail?.payment_timeline
                            ? `(${row.delivery_and_payment_detail.payment_timeline} Days)`
                            : ""}
                        </Typography>
                        <Typography variant="caption">
                          Est Delivery:{" "}
                          {row.delivery_and_payment_detail.delivery_timeline}{" "}
                          Days
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexWrap: { xs: "wrap", sm: "nowrap" },
                          marginBottom: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            maxWidth: "60%",
                            cursor: "pointer",
                          }}
                          title={row.seller_name}
                        >
                          Seller : {row.seller_name}
                        </Typography>
                        {/* <Typography
                  variant="caption"
                  sx={{
                    fontWeight:  "normal",
                  }}
                >
                  Expiry (Negotiation): <span style={{color:"red"}}>{row?.negotiation_detail?.is_expired ? "Expired" : row?.negotiation_detail?.expired_in}</span>
                </Typography> */}
                      </Box>

                      {/* Status and Total */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: { xs: "wrap", sm: "nowrap" },
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ fontWeight: 500, color: "#69829f" }}
                        >
                          Status:{" "}
                          <span style={{ color: "orange" }}>
                            {handleStatus(row)}
                          </span>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 500, color: "primary.main" }}
                        >
                          Total: ₹{" "}
                          {row.final_price * row.final_quantity ||
                            row.price * row.quantity}
                        </Typography>
                      </Box>

                      <Divider sx={{ marginTop: 1, marginBottom: 1 }} />

                      {/* Actions */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#333",
                            fontWeight: "500",
                            cursor: "pointer",
                            borderRadius: "8px",
                            backgroundColor: "#3333", // Light gray background
                            padding: "4px 8px",
                            transition: "background-color 0.3s",
                            "&:hover": {
                              color: "#ff8000",
                              backgroundColor: "#fff8e1",
                            },
                          }}
                          onClick={() => handleNegotiation(row)}
                        >
                          {row?.is_initial_relationship ? "BID" : "Sellers"}{" "}
                          &rarr;
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f4f4f4",
                            borderRadius: "8px",
                            padding: "4px 8px",
                            cursor: "pointer",
                            transition: "background-color 0.3s",
                            "&:hover": { backgroundColor: "#e0e0e0" },
                          }}
                          onClick={(e) => handleGenerateInvoice(e, row)}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: "#333", fontWeight: "500" }}
                          >
                            View Details &rarr;
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <NoData val="trade" />
          )}
        </>
      ) : value === "ongoing" && InitiateTradeShow ? (
        <CreateBuy
          refetch={refetch}
          user_id={user_id}
          UserData={UserData}
          setInitiateTradeShow={setInitiateTradeShow}
          setValue={setValue}
        />
      ) : value === "selfInitiated" && !InitiateTradeShow ? (
        <BuyerLeadList
          user_id={user_id}
          UserData={UserData?.erp_user}
          activeCard={activeCard}
          InitiateTradeShow={InitiateTradeShow}
          triggerTab2Api={triggerTab2Api}
        />
      ) : value === "selfInitiated" && InitiateTradeShow ? (
        <CreateBuy
          refetch={refetch}
          user_id={user_id}
          UserData={UserData}
          setInitiateTradeShow={setInitiateTradeShow}
          setValue={setValue}
        />
      ) : (
        ""
      )}
      <Modal
        show={negotiationModal}
        onHide={() => {
          setNegotiationModal(false);
          setNegotiationView(null);
        }}
        size={negotiationView !== null ? "xl" : "md"}
      >
        <Modal.Header closeButton>
          <Modal.Title className="f300">
            Details{" "}
            {negotiationItem?.is_initial_relationship ? (
              <span className="text-warning">
                ( Seller Available Stock :{" "}
                {availableStock ? availableStock : "0"} Quintals ){" "}
              </span>
            ) : (
              ""
            )}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          {negotiationItem?.is_initial_relationship ? (
            <>
              <div
                style={{
                  borderRadius: "8px",
                  lineHeight: "1.6",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    margin: "10px 0",
                  }}
                >
                  <div>
                    <b>Quoted Price :</b>{" "}
                    <span style={{ color: "orange" }}>
                      ₹ {negotiationItem?.price}
                    </span>
                  </div>
                  <div>
                    <b>Quoted Quantity :</b>{" "}
                    <span style={{ color: "orange" }}>
                      {negotiationItem?.quantity}{" "}
                      {BuyersActiveList?.unit_of_measure}
                    </span>{" "}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    margin: "10px 0",
                  }}
                >
                  <div>
                    <b>Payment Type :</b>{" "}
                    <span style={{ color: "orange" }}>
                      {
                        negotiationItem?.delivery_and_payment_detail
                          ?.payment_type
                      }
                    </span>
                  </div>
                  <div>
                    <b>Delivery Timeline :</b>{" "}
                    <span style={{ color: "orange" }}>
                      {
                        negotiationItem?.delivery_and_payment_detail
                          ?.delivery_timeline
                      }{" "}
                      Days
                    </span>
                  </div>
                </div>

                {negotiationItem?.delivery_and_payment_detail?.payment_type ===
                  "D+" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      margin: "10px 0",
                    }}
                  >
                    <div>
                      <b>Payment Timeline :</b>{" "}
                      <span style={{ color: "orange" }}>
                        {
                          negotiationItem?.delivery_and_payment_detail
                            ?.payment_timeline
                        }{" "}
                        Days
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <NegotiateWithSeller
                negotiationItem={negotiationItem}
                user_id={user_id}
                BuyersList={BuyersActiveList}
                UserType="Buyer"
                refetch={refetch}
                setNegotiationView=""
                setInterestedBuyerModal={setNegotiationModal}
                setNegotiationModal=""
                queryId={user_id}
                query=""
                //  showFields={showFields} setShowFields={setShowFields}
                negotiatioanValues={negotiatioanValues}
                setNegotiationValue={setNegotiationValue}
                refetchBuyers=""
              />
            </>
          ) : (
            <GetBuyersTradingList
              negotiationItem={negotiationItem}
              user_id={user_id}
              BuyersList={BuyersActiveList}
              UserType="Buyer"
              refetch={refetch}
              setNegotiationView={setNegotiationView}
              negotiationView={negotiationView}
              setInterestedBuyerModal={setNegotiationModal}
              ProcCode={BuyersActiveList.ProcCode}
              setNegotiationItem={setNegotiationItem}
            />
          )}
          {/* <SellerNegotiationModal negotiationItem={negotiationItem} setNegotiationModal={setNegotiationModal} user_id={user_id} BuyersList={BuyersActiveList}  UserType="Buyer" refetch={refetch} setWidth=""/> */}
        </Modal.Body>
      </Modal>
      <Modal show={anchorEl} onHide={handlePopoverClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            Quality Parameters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "2%" }}>
          <QualityParamsModal qualityParams={qualityParams} />
        </Modal.Body>
      </Modal>
      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Delivery Docs</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <DeliveryDocs
            FullList={FullList}
            user_id={user_id}
            handleClose={handleClose}
            refetch={refetch}
            AddResponse={AddResponse}
            refetchAddResponse={refetchAddResponse}
          />
        </Modal.Body>
      </Modal>
      <Modal show={showPayment} onHide={handleClosePayment} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Payment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div class="row mt-2">
            <PaymentDocs
              FullList={FullList}
              user_id={user_id}
              refetch={refetch}
              handleClosePayment={handleClosePayment}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Popover
        open={Boolean(anchorElPayment)}
        anchorEl={anchorElPayment}
        onClose={handlePopoverClosePayment}
        anchorOrigin={{
          vertical: "center", // Align vertically with the middle of the row
          horizontal: "right", // Open to the right of the row
        }}
        transformOrigin={{
          vertical: "center", // Align the popover content to the middle of its trigger
          horizontal: "left", // Open the content from the left of the popover
        }}
        PaperProps={{ style: { maxWidth: "300px", padding: "16px" } }} // Adjust spacing
      >
        <CancelIcon
          fontSize="small"
          style={{
            color: "#1976D2",
            float: "right",
            cursor: "pointer",
            marginBottom: "10px",
          }}
          onClick={handlePopoverClosePayment}
        />

        <div>
          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#1976D2",
                }}
              ></span>
              Download Purchase Order
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                onClick={() => handleDownload(FullList.all_media)}
              >
                Click
              </span>{" "}
              to Download <b>Purchase</b> Order.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor:
                    FullList?.status === "Purchase Order Generated"
                      ? "#1976D2"
                      : "#CCC",
                }}
              ></span>
              Upload Purchase Order
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{
                  cursor:
                    FullList?.status === "Purchase Order Generated"
                      ? "pointer"
                      : "not-allowed",
                }}
                onClick={
                  FullList?.status === "Purchase Order Generated"
                    ? (e) => handleUploadIconClick(e, FullList)
                    : undefined
                }
              >
                Click
              </span>{" "}
              to upload your <b>Purchase</b> Order.
            </p>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#1976D2",
                }}
              ></span>
              Invoice Generation
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              Invoice generation will be done by the admin and seller.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#1976D2",
                }}
              ></span>
              Dispatch Documents
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              Dispatch documents will be uploaded by the seller after the
              invoice is generated.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: FullList?.document_status?.dispatched
                    ? "#1976D2"
                    : "#CCC",
                }}
              ></span>
              Delivery Documents
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{
                  cursor: FullList?.document_status?.dispatched
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={
                  FullList?.document_status?.dispatched
                    ? () => handleDeliveryModal(FullList)
                    : undefined
                }
              >
                Click
              </span>{" "}
              to upload your <b>Delivery</b> documents.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: FullList?.document_status?.delivered
                    ? "#1976D2"
                    : "#CCC",
                }}
              ></span>
              Payment Documents
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{
                  cursor: FullList?.document_status?.delivered
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={
                  FullList?.document_status?.delivered
                    ? () => handlePaymentModal(FullList)
                    : undefined
                }
              >
                Click
              </span>{" "}
              to upload your <b>Payment</b> documents.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor:
                    FullList?.status === "Completed" ? "#1976D2" : "#CCC",
                }}
              ></span>
              Trade Completion
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              Please wait for admin approval to mark the trade as completed.
            </p>
          </div>
        </div>
      </Popover>

      <Modal show={anchorElDo} onHide={handleCloseDo} size="small">
        <Modal.Header closeButton>
          <Modal.Title> Purchase Order</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Typography variant="body2" gutterBottom>
            Upload Purchase Order
          </Typography>
          <input
            type="file"
            accept=".pdf"
            onChange={handleFileChange}
            className="form-control mb-2"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleFileUpload}
            className="mt-1"
            fullWidth
          >
            Submit
          </Button>
        </Modal.Body>
      </Modal>

      <Modal show={anchorElInvoice} onHide={handleCloseInvoice} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2 p-lg-4">
          {/* <ViewInvoice procId={FullList.ProcCode} invoice="invoice_2" FullList={FullList}/>    */}
          <DetailDescriptionSeller
            data={FullList}
            invoice="invoice_2"
            procCode={FullList.ProcCode}
            type="Buyer"
            showBuyerName={false}
            user_id={user_id}
          />
          <Divider sx={{ margin: "10px 0" }} />
        </Modal.Body>
      </Modal>
      <Popover
        open={Boolean(anchorTimeline)}
        anchorEl={anchorTimeline}
        onClose={() => setAnchorTimeline(null)}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ style: { maxWidth: "260px", padding: "16px" } }}
      >
        <IconButton
          size="small"
          onClick={() => setAnchorTimeline(null)}
          sx={{ color: "grey.600", float: "right" }}
        >
          <CancelIcon fontSize="small" />
        </IconButton>
        <Typography variant="subtitle1" gutterBottom>
          Modify Timeline
        </Typography>
        <Select
          value={selectedDay}
          onChange={(e) => setSelectedDay(e.target.value)}
          displayEmpty
          fullWidth
          size="small"
          sx={{ mb: 2 }}
        >
          <MenuItem value="" disabled>
            Select Days
          </MenuItem>
          <MenuItem value={1}>1 Day</MenuItem>
          <MenuItem value={2}>2 Days</MenuItem>
          <MenuItem value={3}>3 Days</MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleIncreaseTimeline}
          fullWidth
          size="small"
        >
          Submit &nbsp; {timelineloader ? <Spinner size="sm" /> : ""}
        </Button>
      </Popover>

      {/* <Modal show={createTradeOpen} onHide={()=>setCreateTrade(false)} size="xl">
      <Modal.Header closeButton >
        <Modal.Title >
        Initiate Trade
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3">
      <CreateBuy refetch={refetch} user_id={user_id} UserData={UserData}/>

      </Modal.Body>
    </Modal> */}
    </div>
  );
};

export default BuyerCart;
